<template>
    <div :class="['form-input',{'focus': focus || focus2},{'error': !dataValid}]">
        <div :class="['input-label',{'active': inputValue}]" @click="focused()" v-html="label"></div>
        <div class="flex">
            <div :class="['input-1',{'focus': focus}]" :style="{'width': firstInputWidth}">
                <input :type="type"
                       ref="input"
                       @focus="focus = true"
                       @blur="blur(1)"
                       :tabindex="tabindex"
                       v-model="inputValue1"/>
                <div class="focus-line"></div>
            </div>

            <p v-show="inputValue2.length || inputValue.length || focus || focus2" class="slash">/</p>

            <div v-show="inputValue2.length || inputValue.length || focus || focus2" :class="['input-2', {'focus': focus2}]">
                <input :type="type"
                       ref="input2"
                       @keydown.delete="secondInputChange($event)"
                       @focus="focus2 = true"
                       @blur="blur(2)"
                       :tabindex="tabindex"
                       v-model="inputValue2"/>
                <div class="focus-line"></div>
            </div>
        </div>

        <p v-show="!dataValid" class="error-text">{{dataError}}</p>

    </div>
</template>

<script>

    export default {
        name: "input-series-number",
        data() {
            return {
                inputValue1: "",
                inputValue2: "",
                focus: false,
                focus2: false,
                dataValid: true,
                dataError: ""
            }
        },
        props: {
            type: {
                type: String,
                default: "text"
            },
            value: {
                type: [String, Number],
                default: ""
            },
            label: {
                type: String,
                default: "label"
            },
            valid: {
                type: Boolean,
                default: true
            },
            error: {
                type: String,
                default: ""
            },
            lengths: {
                type: Array,
                default: () => [5, 13]
            },
            tabindex: {
                type: Number
            }
        },
        computed: {
            firstInputWidth() {
                let res = "100%";
                if (!this.focus && !this.focus2) {
                    res = "100%";
                    if (this.inputValue2.length || this.inputValue.length) res = (this.lengths[0] * 6) + "%";
                } else {
                    res = (this.lengths[0] * 6) + "%"
                }
                return res
            },
            inputValue: {
                get() {
                    if (!this.inputValue1.length && !this.inputValue2.length) return "";

                    return this.inputValue1 + "/" + this.inputValue2
                },
                set(val) {
                    this.inputValue1 = val.split("/")[0] || "";
                    this.inputValue2 = val.split("/")[1] || ""
                }
            }
        },
        mounted() {
            window.addEventListener("click", this.click);
            this.inputValue = this.value;
            this.dataValid = this.valid;
            this.dataError = this.localizeList[this.error];
        },
        methods: {
            click() {
                this.$nextTick(() => {
                    if (this.focus && !this.focus2) {
                        // this.focus = false
                    } else if (!this.focus && this.focus2) {
                        // this.focus2 = false
                    }
                })
            },
            secondInputChange() {
                if (!this.inputValue2.length) {
                    this.$refs.input.focus();
                }
            },
            focused() {
                this.$refs.input.focus();
            },
            blur(n = null) {
                setTimeout(() => {
                    if (n === 1) {
                        this.focus = false;
                    } else if (n === 2) {
                        this.focus2 = false;
                    } else {
                        this.focus = false;
                        this.focus2 = false;
                    }
                },0)
            },
        },
        watch: {
            value(val) {
                this.inputValue = val
            },
            localizeList(val) {
                this.dataError = val[this.error];
            },
            inputValue(val) {
                this.$emit("input", val)
            },
            inputValue1(val) {
                if (val.length > this.lengths[0]) {
                    this.inputValue1 = this.inputValue1.slice(0, this.lengths[0]);
                    this.$refs["input2"].focus()
                }
            },
            inputValue2(val) {
                if (val.length > this.lengths[1]) {
                    this.inputValue2 = this.inputValue2.slice(0, this.lengths[1])
                }
            },
            valid(val) {
                this.dataValid = val
            },
            error(val) {
                this.dataError = this.localizeList[val]
            },
            // focus(val) {
            //     if (!val)
            //         this.$emit("blur", true);
            //     else
            //         this.$emit("focus", true);
            // },
        },
        filters: {
            capitalize(val) {
                return val.charAt(0).toUpperCase() + val.slice(1)
            }
        }
    }
</script>

<style scoped>
    .form-input {
        position: relative;
    }
    .form-input input {
        width: 100%;
        outline: none;
        border: none;
        border-bottom: 1px solid #aaa;
        padding: 5px 0;
        margin-top: 20px;
        font-weight: 500;
        font-size: 15px;
        color: #1D1D1D;
        box-shadow: inset 0 0 0 50px var(--white-color);
    }
    .form-input .input-1 {
        width: 100%;
    }
    .form-input.focus .input-1 {
        width: 30%;
    }
    .form-input .input-2 {
        width: auto;
    }
    .form-input .slash {
        color: #aaa;
        margin: 0 4px 0 6px;
        align-self: flex-end;
    }
    .error.form-input input {
        border-bottom: 1px solid red;
    }
    .form-input .input-1,
    .form-input .input-2 {
        position: relative;
    }
    .form-input .input-1 .focus-line,
    .form-input .input-2 .focus-line {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background-color: var(--primary-color);
        transition: all .4s;
    }
    .form-input .focus.input-1 .focus-line,
    .form-input .focus.input-2 .focus-line {
        left: 0;
        width: 100%;
    }
    .error.form-input:before {
        left: 50%;
        width: 0;
    }
    .form-input .input-label {
        position: absolute;
        top: calc(50% + 4px);
        transform: translateY(-50%);
        font-size: 15px;
        color: var(--lighten-5-color);
        z-index: 1;
        transition: all .2s;
    }
    .form-input .input-label.active {
        top: 6px;
        transform: translateY(0);
        font-size: 13px;
        font-weight: 300;
    }
    .form-input.focus .input-label {
        top: 6px;
        transform: translateY(0);
        font-size: 13px;
        font-weight: 300;
        color: var(--primary-color);
    }
    .form-input .error-text {
        position: absolute;
        left: 0;
        top: calc(100% + 3px);
        color: red;
        font-size: 12px;
    }
</style>
